import { Component, Input, OnInit, input } from '@angular/core';
import { MaterialModule } from 'jk-service';
import { JkBaseComponent, } from 'jk-service';
import { idNameItem, newOpenwinLoadOption } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule, JkgridwinComponent } from 'jk-advcom';

@Component({
  selector: 'app-order-stock',
  standalone: true,
  imports: [
    MaterialModule,
    AdvComModule,
    JackBaseComponentModule,
  ],
  templateUrl: './order-stock.component.html',
  styleUrl: './order-stock.component.css'
})
export class OrderStockComponent extends JkBaseComponent implements OnInit {
  // 即時庫存
  stkmqGrid!: JkgridwinComponent;
  _account: string = '91840128692';
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() get account(): string {
    return this._account;
  }
  set account(value: string) {
    this._account = value;
    this.doQuery();
  }
  readonly accountList = input<idNameItem[]>([]);
  readonly userId = input<string>('');
  constructor() {
    super();

  }
  override ngOnInit() {
    super.ngOnInit();
    if (this.orm) {
      let n = newOpenwinLoadOption('STKMQ', '002', 'S', [], this.accountList());
      this.openwinLoadOpts.push(n);
      this.orm.loadOpenwinOptions(this.openwinLoadOpts);
    }
  }
  afterGridReady($event: JkgridwinComponent) {
    this.stkmqGrid = $event;
    this.doQuery();
  }
  doQuery() {
    if (!this.account) return;
    let where = ` AND MQ002='${this.account}'`;
    this.stkmqGrid.doQuery2('STKMQ', '001', 'S', where);
  }

}
